/** @jsx h */
import TeaserGlobal from './Teaser/TeaserGlobal';
import TeaserPublications from './Teaser/TeaserPublications';
import TeaserOrte from './Teaser/TeaserOrte';

const ResultTeaser = ({ searchType, result, restrictionFilters }) => {
  // Determine correct value for `result.url`
  const rootId = restrictionFilters?.rootId || false;
  const replaceUrl =
    rootId &&
    result?.urls?.length > 0 &&
    result.urls.filter(
      url => url.root.toString() === restrictionFilters.rootId
    );

  result.url = replaceUrl[0]?.url || result.url;

  // Select which teaser to render
  switch (searchType) {
    case 'global':
      return <TeaserGlobal result={result} />;
    case 'publications':
      return <TeaserPublications result={result} />;
    case 'location':
      return <TeaserOrte result={result} />;
    default:
      return <TeaserGlobal result={result} />;
  }
};

export default ResultTeaser;
